import React from "react";
import Footer from "../components/Footer";
import "./LegalPages.css";

const CompanyPolicy = () => {
  return (
    <>
      <section className="legal-page">
        <div className="legal-page-container">
          <h1>Company Policy</h1>
          <p className="legal-updated">Last updated: March 2, 2026</p>

          <h2>Purpose</h2>
          <p>
            This Company Policy defines how Lattice Labs operates with clients,
            partners, employees, and contractors. It sets clear expectations for
            ethical conduct, confidentiality, compliance, and quality delivery.
          </p>

          <h2>Code Of Conduct</h2>
          <ul>
            <li>We maintain professional, respectful, and inclusive behavior.</li>
            <li>We do not tolerate harassment, discrimination, or retaliation.</li>
            <li>
              We avoid conflicts of interest and disclose any potential concerns
              early.
            </li>
          </ul>

          <h2>Confidentiality And Data Handling</h2>
          <ul>
            <li>
              Client data is accessed only by authorized team members with a
              business need.
            </li>
            <li>
              Sensitive information must not be shared outside approved channels.
            </li>
            <li>
              Internal and client documentation must follow secure storage and
              retention controls.
            </li>
          </ul>

          <h2>Information Security</h2>
          <ul>
            <li>
              Team members use strong authentication and approved secure tools.
            </li>
            <li>
              Systems and dependencies are reviewed and updated on a regular
              schedule.
            </li>
            <li>
              Security incidents are reported and triaged without unnecessary
              delay.
            </li>
          </ul>

          <h2>Quality And Delivery Standards</h2>
          <ul>
            <li>
              Projects follow documented processes for planning, implementation,
              testing, and release.
            </li>
            <li>
              Work products are reviewed to ensure reliability, maintainability,
              and performance.
            </li>
            <li>
              Client feedback is integrated continuously to improve outcomes.
            </li>
          </ul>

          <h2>Compliance</h2>
          <p>
            We comply with applicable laws and regulations relevant to our
            operations, including contractual obligations, intellectual property
            rights, and data protection requirements.
          </p>

          <h2>Policy Updates</h2>
          <p>
            This policy may be updated as our business and legal obligations
            evolve. Material changes are reflected through the updated date on
            this page.
          </p>

          <div className="legal-contact">
            <h2>Contact</h2>
            <p>
              For policy questions, contact us at{" "}
              <a href="mailto:info@latticelabs.com">info@latticelabs.com</a>.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CompanyPolicy;
